import http from '@/shared/api/http'

export async function getDependencies(parentValueId, childAttributeId = null) {
  const params = childAttributeId ? { childAttributeId } : undefined
  const response = await http.get(`/attribute-value-dependencies/${parentValueId}`, { params })
  return response.data
}

export async function replaceDependencies(parentValueId, childCharacteristicValueIds, childAttributeId = null) {
  const response = await http.put(`/attribute-value-dependencies/${parentValueId}`, {
    childCharacteristicValueIds,
    childAttributeId
  })
  return response.data
}
